/** ***********************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2021 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe Inc. (“Adobe”) and its suppliers,
* if any.  The intellectual and technical concepts contained
* herein are proprietary to Adobe and its
* suppliers and are protected by all applicable intellectual property
* laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
************************************************************************* */

import WebPage from '@react/react-spectrum/Icon/WebPage';
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop';
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone';
import DeviceTablet from '@react/react-spectrum/Icon/DeviceTablet';
import Brush from '@react/react-spectrum/Icon/Brush';
import Circle from '@react/react-spectrum/Icon/Circle';
import Cloud from '@react/react-spectrum/Icon/Cloud';
import Images from '@react/react-spectrum/Icon/Images';
import Tips from '@react/react-spectrum/Icon/Tips';
import Folder from '@react/react-spectrum/Icon/Folder';
import Export from '@react/react-spectrum/Icon/Export';
import Import from '@react/react-spectrum/Icon/Import';
import Document from '@react/react-spectrum/Icon/Document';
import TextEdit from '@react/react-spectrum/Icon/TextEdit';
import Article from '@react/react-spectrum/Icon/Article';
import Image from '@react/react-spectrum/Icon/Image';
import Icon3DMaterials from '@react/react-spectrum/Icon/3DMaterials';
import SocialNetwork from '@react/react-spectrum/Icon/SocialNetwork';
import Effects from '@react/react-spectrum/Icon/Effects';
import Experience from '@react/react-spectrum/Icon/Experience';
import VoiceOver from '@react/react-spectrum/Icon/VoiceOver';
import Multiple from '@react/react-spectrum/Icon/Multiple';
import Audio from '@react/react-spectrum/Icon/Audio';
import AdobeLogo from '@react/react-spectrum/Icon/AdobeLogo';
import Note from '@react/react-spectrum/Icon/Note';
import ViewGrid from '@react/react-spectrum/Icon/ViewGrid';
import CoverImage from '@react/react-spectrum/Icon/CoverImage';
import Code from '@react/react-spectrum/Icon/Code';
import Edit from '@react/react-spectrum/Icon/Edit';
import ShowAllLayers from '@react/react-spectrum/Icon/ShowAllLayers';
import ImageAutoMode from '@react/react-spectrum/Icon/ImageAutoMode';
import VectorDraw from '@react/react-spectrum/Icon/VectorDraw';
import Shapes from '@react/react-spectrum/Icon/Shapes';
import CloneStamp from '@react/react-spectrum/Icon/CloneStamp';
import News from '@react/react-spectrum/Icon/News';
import PeopleGroup from '@react/react-spectrum/Icon/PeopleGroup';
import Print from '@react/react-spectrum/Icon/Print';
import Cut from '@react/react-spectrum/Icon/Cut';
import MovieCamera from '@react/react-spectrum/Icon/MovieCamera';
import Preset from '@react/react-spectrum/Icon/Preset';
import IntersectOverlap from '@react/react-spectrum/Icon/IntersectOverlap';
import DesktopAndMobile from '@react/react-spectrum/Icon/DesktopAndMobile';

const ICON_MAP = {
    desktop: DeviceDesktop,
    mobile: DevicePhone,
    web: WebPage,
    tablet: DeviceTablet,
    brush: Brush,
    cloud: Cloud,
    images: Images,
    lightbulb: Tips,
    circle: Circle,
    desktopandmobile: DesktopAndMobile,
    devicedesktop: DeviceDesktop,
    showalllayers: ShowAllLayers,
    imageautomode: ImageAutoMode,
    vectordraw: VectorDraw,
    shapes: Shapes,
    clonestamp: CloneStamp,
    news: News,
    peoplegroup: PeopleGroup,
    print: Print,
    cut: Cut,
    moviecamera: MovieCamera,
    preset: Preset,
    intersectoverlap: IntersectOverlap,
    folder: Folder,
    // ImageSearch,
    export: Export,
    import: Import,
    document: Document,
    textedit: TextEdit,
    // IdSolid,
    article: Article,
    image: Image,
    '3dmaterials': Icon3DMaterials,
    socialnetwork: SocialNetwork,
    effects: Effects,
    experience: Experience,
    voiceover: VoiceOver,
    multiple: Multiple,
    // RealTimeCustomerProfile,
    edit: Edit,
    audio: Audio,
    adobelogo: AdobeLogo,
    // PrSolid,
    note: Note,
    viewgrid: ViewGrid,
    coverimage: CoverImage,
    webpage: WebPage,
    code: Code,
};

export function getIcon(icon) {
    if (ICON_MAP[icon]) {
        return ICON_MAP[icon];
    }
    return null;
}
